import { ConnectWithUsButton } from "../components/ConnectWithUsButton";
import { SchoolSection } from "../components/SchoolSection";
import { useSchoolLocal } from "../useSchoolLocal";
import { PitchVideo } from "./PitchVideo";

export const SchoolHero = () => {
  const { t, headingFont } = useSchoolLocal();

  return (
    <SchoolSection
      className="border-b border-[#EBEBEB] bg-white"
      contentClassName="grid items-center gap-10 py-10 md:grid-cols-2 md:py-14"
    >
      <article className="flex flex-col gap-4 md:gap-6">
        <h1
          className={`text-[32px] font-bold leading-tight md:text-5xl md:leading-[56px] ${headingFont}`}
        >
          {t("hero.title")}
        </h1>
        <p className="text-[18px] text-[#3D3C56]">{t("hero.lead")}</p>
        <p className="text-[16px] font-semibold">{t("hero.support")}</p>
        <ConnectWithUsButton className="w-full md:w-fit" />
      </article>
      <PitchVideo />
    </SchoolSection>
  );
};
